// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"7d1c8a54","53":"bc41f6e7","195":"d321c5ec","415":"f684c242","787":"110e0204"}[chunkId] + ".chunk.js";
};